import {View} from 'MWC';
import tpl from '../templates/career';
import buildUrl from 'utils/buildGetURLWithParams';
import {apiback} from '../../../config';
import PropTypes from 'prop-types';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);
        this.state = {
            ui: this.uiStates.INITIAL,
            vacancies: [],
            tag: null,
            limit: 6,
            offset: 0,
            sort_by: ['date'],
            order_by: ['DESC'],
            preload: true,
            showTooltip: false,
            tooltipText: '',
            tooltipElement: null
        };
        this.model = this.getModel();

        return this;
    }

    componentDidMount() {
        this.getVacancies();
    }

    changeFilter = event => {
        this.model.resetParams();
        const {target} = event,
            {name} = target?.props || target,
            {value} = target?.props || target;
        this.model.setParam(value, name);
    };

    getVacancies = () => {
        const {sort_by, order_by, offset, limit} = this.state,
            pageParams = {sort_by, order_by, offset, limit};
        const url = buildUrl(apiback('API_VACANCIES'), pageParams);

        fetch(url)
            .then(res => res.json())
            .then(({data, total}) => {
                data &&
                    this.setState(prevState => ({
                        vacancies: data,
                        total,
                        preload: false
                    }));
            });
        // .catch(x => console.log('error:', x)); //todo добавить обработчик
    };

    setTooltipState(event, state, text) {
        if (text && text.length > 45) {
            this.setState({
                showTooltip: state,
                tooltipText: text,
                tooltipElement: event.currentTarget
            });
        } else {
            this.setState({showTooltip: false});
        }
    }

    static contextTypes = {
        app: PropTypes.object
    };
}
